import { Action } from '@ngrx/store';

export const VERSORGUNGSVERTRAEGE_FIX_FEHLER =
  '[VV SHARED] FIX HINTERLEGTEN FEHLER';

export class VVFixFehlerAction implements Action {
  readonly type = VERSORGUNGSVERTRAEGE_FIX_FEHLER;
}
